import { Stack, createStyles } from '@mantine/core';
import { Title } from '@repo/foundations';
import React from 'react';
import { Helmet } from 'react-helmet';
import { QueryListLookbackDaysButton } from '../../components/QueryListV2/QueryListLookbackDaysButton';
import {
	NavBarBreadcrumbWrapper,
	NavBarRightSideWrapper,
	NavBarWrapper,
} from '../../components/SecodaAppShell/SecodaNavBar';
import { QueryDrawerController } from '../../features/QueryDrawer/QueryDrawerController';
import { QueryDrawerProvider } from '../../features/QueryDrawer/QueryDrawerProviderController';
import { WorkspaceQueriesTable } from './components/WorkspaceQueriesTable';

const useStyles = createStyles((theme) => ({
	content: {
		marginLeft: theme.spacing['2xl'],
		marginRight: theme.spacing['2xl'],
		width: `calc(100% - (2 * ${theme.spacing['2xl']}))`,
		flexGrow: 1,
	},
}));

function WorkspaceQueriesPage() {
	const [lookBackDays, setLookBackDays] = React.useState(7);
	const { classes } = useStyles();

	return (
		<QueryDrawerProvider>
			<Stack spacing={0} style={{ flexGrow: 1 }}>
				<Helmet>
					<title>Workspace Queries</title>
				</Helmet>
				<NavBarWrapper>
					<NavBarBreadcrumbWrapper>
						<Title
							order={1}
							size="sm"
							data-testid="workspace-queries-nav-bar-title"
						>
							Queries
						</Title>
					</NavBarBreadcrumbWrapper>
					<NavBarRightSideWrapper>
						<QueryListLookbackDaysButton
							lookBackDays={lookBackDays}
							handleSetLookbackDays={setLookBackDays}
							options={[1, 7, 30]}
						/>
					</NavBarRightSideWrapper>
				</NavBarWrapper>
				<Stack className={classes.content}>
					<WorkspaceQueriesTable lookBackDays={lookBackDays} />
				</Stack>
				<QueryDrawerController />
			</Stack>
		</QueryDrawerProvider>
	);
}

export default WorkspaceQueriesPage;
